import {cashbackPercent,rewardType} from '../components/club/cashbackOrdering';
export const normalize=v=>String(v||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
const aliases={celular:'smartphone',computador:'notebook',remedio:'farmacia',bicho:'pets',viagem:'viagens'};
export function validPercent(brand){const value=cashbackPercent(brand);return value!==null&&value>=0&&value<=100?value:null;}
export function findBrands(brands,{q='',category='',kind='',order='cashback_desc',selection='',favoritesOnly=false,favorites=[]}){
 const tokens=normalize(q).trim().split(/\s+/).filter(Boolean);
 return brands.filter(b=>!b.hidden&&(!category||b.categories.some(c=>c.id===category))&&(!kind||rewardType(b)===kind)&&(!selection||b.selection===selection)&&(!favoritesOnly||favorites.includes(String(b.id)))&&tokens.every(t=>{
  const text=normalize([b.name,b.description,b.editorial_note,...b.categories.map(c=>c.label)].join(' '));return text.includes(t)||(aliases[t]&&text.includes(aliases[t]));
 })).sort((a,b)=>{
  const name=(a.name||'').localeCompare(b.name||'','pt-BR');
  if(order==='name')return name;
  if(order==='newest')return String(b.first_seen).localeCompare(String(a.first_seen))||name;
  const x=validPercent(a),y=validPercent(b);
  if(x===null||y===null)return x===y?name:x===null?1:-1;
  return (order==='cashback_asc'?x-y:y-x)||name;
 });
}
export function reminderDue(p,now=Date.now()){return p.consent===true&&now-Number(p.lastShown||0)>=7*86400000;}
export const THEMES=[
 {label:'Cuide de você',categories:['saude','beleza','esportes']},
 {label:'Casa em dia',categories:['casa','construcao']},
 {label:'Viagem e lazer',categories:['viagens','lazer']},
 {label:'Universo geek',categories:['games','tecnologia']},
 {label:'Família e pets',categories:['infantil','pets']},
];
